
import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ISignInActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";

export class SignInAction extends BaseAction<void, ISignInActionParams> {
    override async run(): Promise<void> {
        try {
            const { isAuthenticated, login, guestCheckoutBookingId = "" } = this.params! || { isAuthenticated: false, login: () => { } };
            if (isAuthenticated) {

                // Reset active account action
                updateRecoilState("activeAccountActionAtom", "");
                updateRecoilState("subActiveAccountActionAtom", "");

                // Emit an event to indicate route change
                _eventBus.emit({
                    eventName: "ROUTE_CHANGE",
                    data: "/my-account",
                })
            } else {
                if (guestCheckoutBookingId !== "") {
                    /* After login redirect to checkout page */
                    sessionStorage.setItem("redirectAfterLogin", "/checkout");
                    /**
                     * Need to remove checkoutFromWithLogin
                     * If layout page does not find checkoutFromWithLogin then it will start checkout flow
                     * */
                    sessionStorage.removeItem("checkoutFromWithLogin");
                    /**
                     * Need to check guest booking id.
                     * Because, once user redirect to checkout page after login
                     * We need to fetch booking
                     * */
                    sessionStorage.setItem("guestCheckoutBookingId", guestCheckoutBookingId)
                    /* Once id store to session need to set recoil empty to prevent action call again. */
                    updateRecoilState("guestCheckoutBookingIdAtom", "")
                }
                login();
            }
        } catch (error) {
            console.error("Error during sign in:", error);
        }
    }
}

// Create a singleton instance of the action
export const signInAction = new SignInAction();
